export default __webpack_public_path__ + "static/media/header_background.3d0685c7.png";